__turbopack_context__.v({
  "meteor": "meteors-module__oHgfAW__meteor",
  "tail": "meteors-module__oHgfAW__tail",
});
